import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './assets/styles/common.css'

// 创建Vue应用实例
const app = createApp(App)

// 使用路由
app.use(router)

// 挂载应用
app.mount('#app')

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue全局错误:', err)
  console.log('错误信息:', info)
}

// 百度统计脚本
if (process.env.NODE_ENV === 'production') {
  const hm = document.createElement("script")
  hm.src = "https://hm.baidu.com/hm.js?7c31a4cd669f0c8c09c59127426c0f10"
  const s = document.getElementsByTagName("script")[0]
  s.parentNode.insertBefore(hm, s)
  // 修复ESLint错误：删除未使用的_hmt变量
}